import { render, staticRenderFns } from "./Base_dic.vue?vue&type=template&id=acc6e764&scoped=true"
import script from "./Base_dic.vue?vue&type=script&lang=js"
export * from "./Base_dic.vue?vue&type=script&lang=js"
import style0 from "./Base_dic.vue?vue&type=style&index=0&id=acc6e764&prod&lang=less&scoped=true"
import style1 from "./Base_dic.vue?vue&type=style&index=1&id=acc6e764&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc6e764",
  null
  
)

export default component.exports